import { render, staticRenderFns } from "./InvoicesAddRX.vue?vue&type=template&id=5d8ea95b&scoped=true&"
import script from "./InvoicesAddRX.vue?vue&type=script&lang=js&"
export * from "./InvoicesAddRX.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesAddRX.vue?vue&type=style&index=0&id=5d8ea95b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ea95b",
  null
  
)

export default component.exports